// Default
import './bootstrap'

// Global Object
window.app = window.app || {}
app.errors = []
app.success = []

// We'll load jQuery and libraries.
try {
  window.$ = window.jQuery = require('jquery')
  require('paroller.js')
  // require('../../../node_modules/...')
} catch (e) {}

// Polyfill
import './polyfill'

// Watermark
import './watermark'

// Browse happy
import browseHappy from './browse-happy'

// Dispatch
import dispatch from './controllers'

// Packages
import dimentions from './helpers/dimentions'

// Our packages
import defaultAlerts from './components/alerts'
import menu from './components/menu'

// Initializers
const docReady = () => {
  new browseHappy().init()
  new dispatch().init()
  new dimentions().init()
  new defaultAlerts().init()
  new menu().init()
  // --
  $("[data-paroller-factor]").paroller()
}

const winLoad = () => {
  // ...
}

const docReadyWinload = () => {
  // ...
}

// ---
// [IMPORTANT] Do not change or add anything!
document.addEventListener('DOMContentLoaded', () => {
  docReady()
  docReadyWinload()
}, false)
window.addEventListener('load', () => {
  winLoad()
  docReadyWinload()
}, false )
// ---
// ---


